var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPauseCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-406 -61)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "fill",
    width: 2.667,
    height: 10.667,
    transform: "translate(414 67.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fill",
    width: 2.667,
    height: 10.667,
    transform: "translate(419.333 67.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill",
    d: "M12,1.5A10.5,10.5,0,1,1,1.5,12,10.512,10.512,0,0,1,12,1.5M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Z",
    transform: "translate(406 61)",
    fill: "#fff"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPauseCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pause-circle.206278a620809d2226d3deb1061e1bec.svg";